import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { FieldDefsResolver, ProjectDataResolver, ProjectsFieldDefsResolver } from '../projects/projects.resolvers';
import { ReportingBuilderComponent } from './@components/builder/builder.component';
import { ReportingListComponent } from './@components/list/list.component';
import { ReportingComponent } from './reporting.component';
import { ListWrapperComponent } from './list-wrapper/list-wrapper.component';

const routes: Routes = [
  {
    path: '',
    component: ReportingComponent,
  },
  {
    path: 'list',
    component: ListWrapperComponent,
    children: [
      {
        path: '',
        component: ReportingListComponent,
      },
    ],
  },
  {
    path: 'builder/:id',
    component: ReportingBuilderComponent,
    resolve: {
      fieldDefs: FieldDefsResolver,
      options: ProjectDataResolver,
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ReportingRoutingModule {}
